<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-head">Contents</p>
<p class="toc-part" id="part-1"><a href="#/DeathsShadow_part1">PART ONE: A Whole New World</a></p>
<p class="toc-chapter" id="chap-1"><a href="#/DeathsShadow_chap1">Snapshots of Beranabus I</a></p>
<p class="toc-chapter" id="chap-2"><a href="#/DeathsShadow_chap2">Dead Girls Tell Tales</a></p>
<p class="toc-chapter" id="chap-3"><a href="#/DeathsShadow_chap3">Lonely New World</a></p>
<p class="toc-chapter" id="chap-4"><a href="#/DeathsShadow_chap4">First Contact</a></p>
<p class="toc-chapter" id="chap-5"><a href="#/DeathsShadow_chap5">Sponge</a></p>
<p class="toc-chapter" id="chap-6"><a href="#/DeathsShadow_chap6">Friend Indeed</a></p>
<p class="toc-chapter" id="chap-7"><a href="#/DeathsShadow_chap7">Waking the Dead</a></p>
<p class="toc-chapter" id="chap-8"><a href="#/DeathsShadow_chap8">Fight</a></p>
<p class="toc-chapter" id="chap-9"><a href="#/DeathsShadow_chap9">Flight</a></p>
<p class="toc-chapter" id="chap-10"><a href="#/DeathsShadow_chap10">Waiting for the Cavalry</a></p>
<p class="toc-part" id="part-2"><a href="#/DeathsShadow_part2">PART TWO: Ward Duty</a></p>
<p class="toc-chapter" id="chap-11"><a href="#/DeathsShadow_chap11">Snapshots of Beranabus II</a></p>
<p class="toc-chapter" id="chap-12"><a href="#/DeathsShadow_chap12">A Man’s Gotta Do</a></p>
<p class="toc-chapter" id="chap-13"><a href="#/DeathsShadow_chap13">Up On the Roof</a></p>
<p class="toc-chapter" id="chap-14"><a href="#/DeathsShadow_chap14">Kids’ Stuff</a></p>
<p class="toc-chapter" id="chap-15"><a href="#/DeathsShadow_chap15">The Split</a></p>
<p class="toc-chapter" id="chap-16"><a href="#/DeathsShadow_chap16">Chasing Shadows</a></p>
<p class="toc-part" id="part-3"><a href="#/DeathsShadow_part3">PART THREE: All Aboard</a></p>
<p class="toc-chapter" id="chap-17"><a href="#/DeathsShadow_chap17">Snapshots of Beranabus III</a></p>
<p class="toc-chapter" id="chap-18"><a href="#/DeathsShadow_chap18">Kirilli</a></p>
<p class="toc-chapter" id="chap-19"><a href="#/DeathsShadow_chap19">Her Master’s Voice</a></p>
<p class="toc-chapter" id="chap-20"><a href="#/DeathsShadow_chap20">Ship of the Living Dead</a></p>
<p class="toc-chapter" id="chap-21"><a href="#/DeathsShadow_chap21">Going Down</a></p>
<p class="toc-chapter" id="chap-22"><a href="#/DeathsShadow_chap22">The Only Way</a></p>
<p class="toc-chapter" id="chap-23"><a href="#/DeathsShadow_chap23">All At Sea</a></p>
<p class="toc-chapter" id="teas-1"><a href="#/DeathsShadow_teas1">A Preview of “Wolf Island”</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// DeathsShadow_toc.vue?40543e4c